export default __webpack_public_path__ + "static/media/cloud1.b1609ea9.webp";